import React, { useContext, useMemo } from 'react';
import { GreenTickV2, TickGreyIcon } from 'src/assets/images';
import { CopyRight, ScrollTop, SolutionType } from 'src/features/common';
import { Carousel } from 'src/features/order/components';
import { ApplicationContext } from '../../context';
import { getOnboardingCompleteHeadings } from 'src/features/onboarding/helpers/headings';
import { CardType } from '../../pages/setup-completion/setup-completion';
import './onboarding-complete.scss';
import { cn } from 'src/utils/cn';

interface Props {
  cards: CardType[];
}

export const OnboardingCompleteRevamp = ({ cards }: Props) => {
  const { application } = useContext(ApplicationContext);

  const headings = useMemo(
    () =>
      getOnboardingCompleteHeadings(application.solutionType === SolutionType.thirdPartyOnboarding),
    [application.solutionType],
  );

  return (
    <article className="setup-completion-container">
      <ScrollTop />
      <section className="pt-4 completion-message-container">
        <section className="flex flex-col items-center w-full gap-6">
          <img className="w-16 h-16" src={GreenTickV2} alt="Tick Icon" />
          <section className="flex flex-col items-center w-full gap-6">
            <h1 className="text-4xl font-medium text-grey-750">{headings.main}</h1>
            <p className="text-base font-normal text-grey-750 ">{headings.second}</p>
          </section>
        </section>
      </section>

      <Carousel>
        <section className="flex flex-col">
          <hr />
          <h2 className="text-lg font-bold text-black ">What happens next</h2>
          <article className="flex flex-row gap-5">
            {cards.map(({ title, content, completed }, index) => (
              <section
                key={`setup-complete-card-${index}`}
                className={cn(
                  'flex flex-col justify-start w-50 min-w-50 text-left p-4 pr-3 border border-solid border-grey-400 rounded-4 text-grey-400 h-[170px]',
                  completed && 'border-2 border-blue-600 text-grey-750',
                )}
              >
                <div className="flex items-center h-[30%] w-full">
                  <img
                    className="h-7.5 w-7.5"
                    src={completed ? GreenTickV2 : TickGreyIcon}
                    alt="Tick Icon"
                  />
                  <h5 className="ml-2 text-lg font-normal">{title}</h5>
                </div>
                <p className="mt-4 mr-3 text-xs">{content}</p>
              </section>
            ))}
          </article>
        </section>
      </Carousel>

      <CopyRight />
    </article>
  );
};
